    'use strict';
    module.exports = {
        localhost: 'http://localhost:8883/api/v1',
        backendUrl: '/api/activity',
        goBackendUrl: '/api-v2/activity',
        phpBackendUrl:'/api/v3',
        backendOTCUrl: 'http://3.113.11.184:8887/web',
        mainBackendUrl: '/api/v1',
        socketUrl: 'ws://3.113.11.184:8090/',
        ossUrl: 'https://sipc-p.oss-cn-hangzhou.aliyuncs.com/activity/268',
        assetsSubDirectory: 'static',
        siteId: '1',
    };
